import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";
import { renderErrorPage } from "./lib/error-page";
import { anexarToken } from "@/lib/auth-anexar-token";
import devConfig from "@/../config/dev.config.json";
import "@/lib/locale-init";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    try {
      const { registrarLog } = await import("./lib/log-servidor.server");
      registrarLog(
        "servidor",
        `Falha ao processar requisição: ${(error as Error)?.message ?? String(error)}`,
        { nivel: "erro", detalhes: error },
      );
    } catch {
      // Diário de bordo indisponível: segue com a página de erro.
    }
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  functionMiddleware: [anexarToken],
  requestMiddleware: [errorMiddleware, csrfMiddleware],
}));

// Ativa atalho Ctrl-Q (XOFF) em consoles TTY para encerrar o processo.
if (typeof process !== "undefined" && process.stdin && process.stdin.isTTY) {
  try {
    // Coloca stdin em raw mode para captar Ctrl-Q diretamente
    process.stdin.setRawMode(true);
    process.stdin.resume();
    process.stdin.on("data", (chunk: Buffer) => {
      if (!chunk || chunk.length === 0) return;
      // Ctrl-Q = 0x11
      if (chunk[0] === 0x11) {
        // Emite SIGTERM para reutilizar handlers existentes de shutdown
        try {
          if ((devConfig as any)?.mostrarLogConsole !== false)
            console.log("\nCtrl-Q recebido — encerrando processo...");
        } catch {}
        try {
          process.emit("SIGTERM");
        } catch {
          try {
            process.exit(0);
          } catch {}
        }
      }
    });
  } catch {
    /* ignore e segue sem o atalho */
  }
}
